@let view = recentView();
<button
    #viewPopup
    [disabled]="isDisplaySelectorDisabled"
    class="wk-navbar__action-display"
    [class.wk-navbar__action-display--grid]="view === 'Kanban'"
    [class.wk-navbar__action-display--hierarchy]="view === 'details'"
    [class.wk-navbar__action-display--listBulletDot]="view === 'List'"
    title="{{ 'Navbar.Display' | translate }}"
    placement="bottom"
    triggers="click"
    [outsideClick]="true"
    [popover]="popoverContent"
    (onShown)="onIsDisplaySelectorShown()"
>
    <i></i>
</button>
<ng-template #popoverContent>
    <div
        #displaySelectorPopoverContent
        class="wk-navbar__action-display__options"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        aria-label="display selector"
        cdkTrapFocus
        cdkTrapFocusAutoCapture
    >
        <button
            class="wk-navbar__action-display__option wk-navbar__action-display__option--grid"
            [class.wk-navbar__action-display__option--active]="isKanban_Active"
            (click)="selectOption('Kanban', true); closePopover()"
        >
            <i></i>
            <div class="wk-navbar__action-display__option-title">{{ "Navbar.Cards" | translate }}</div>
        </button>
        <button
            class="wk-navbar__action-display__option wk-navbar__action-display__option--hierarchy"
            [class.wk-navbar__action-display__option--active]="isDetails_Active"
            (click)="selectOption('details', true); closePopover()"
        >
            <i></i>
            <div class="wk-navbar__action-display__option-title">{{ "Navbar.Details" | translate }}</div>
        </button>
        @if(!isJobsBillingDashboard){
            <button
                class="wk-navbar__action-display__option wk-navbar__action-display__option--listBulletDot"
                [class.wk-navbar__action-display__option--active]="isList_Active"
                [class.wk-navbar__action-display__option--disabled]="isListDisabled"
                [disabled]="isListDisabled"
                (click)="selectOption('List', true); closePopover()"
            >
                <i></i>
                <div class="wk-navbar__action-display__option-title">{{ "Navbar.List" | translate }}</div>
            </button>
        }
    </div>
</ng-template>
